<div class="h-dvh w-dvw flex justify-center items-center">
  <app-card>
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">Nur für mobile Geräte</h2>
    <p class="text-gray-600 mb-6">
      Diese Anwendung ist nur für Smartphones und Tablets optimiert. Bitte greifen Sie mit einem
      mobilen Gerät darauf zu.
    </p>
  </app-card>
</div>
